import { createSelector } from 'reselect';
import { selectPage, isModuleVisible, getModulesToHide } from './TopNavHelpers';

export const get_navigation = createSelector(
  [state => state.ConsumerTopNav.navigation, (state, props) => props.current_page],
  (navigation, currentPage) => selectPage(navigation, currentPage),
);

export const burgerMenuItems = () => {
  let menuItems = [];

  if (ADV.util.env('isAdviserArea')) {
    menuItems = [
      {
        dataAction: 'Feedback',
        icon: 'fa fa-question-circle',
        label: 'Get Help',
      },
      {
        dataAction: 'Feedback',
        icon: 'fa fa-comment',
        label: 'Send Feedback',
      },
    ];
  }

  return menuItems.filter(menuItem => isModuleVisible(menuItem.label, getModulesToHide()));
};
